import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FieldsObjectType } from 'vio-input';
import moment, { Moment } from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionService {

  public pageTitle: string = '';
  constructor(private router: Router) { }

  restrictCharacters(str: string) {
    const invalidChars = ["<", ">", "~", "\\", "-", "+", "e"];

    return invalidChars.includes(str);
  }

  unAuthorizedHandlerFunction = (isUnauthorized: boolean) => {
    this.router.navigateByUrl('/login-page');
  }

  assignObjectValuesToVioInputComponent = (formsObjet: FieldsObjectType, valueObject: any) => {
    for (const key of Object.keys(formsObjet)) {
      if (valueObject[key] != undefined && valueObject[key] != null) {
        if (formsObjet[key]['inputType'] == 'multiselect') {
          if (valueObject[key].toString().includes(",")) {
            formsObjet[key]['value'] = valueObject[key].split(",")
          } else if (Array.isArray(valueObject[key])) {
            formsObjet[key]['value'] = valueObject[key];
          } else {
            formsObjet[key]['value'] = [valueObject[key]];
          }
        } else if (formsObjet[key]['inputType'] == 'date') {
          formsObjet[key]['value'] = moment(new Date(valueObject[key])).tz('Asia/Calcutta').format('YYYY-MM-DD')
          console.log(`Value of Date = `, valueObject[key])
          console.log(`Value of Converted Date = `, formsObjet[key]['value']);
          console.log(new Date(valueObject[key]).toISOString())
        }
        else {
          formsObjet[key]['value'] = valueObject[key];
        }
      }
    }
  }

  formatDate = (dt: string | Date, dateFormat: string) => moment(new Date(dt)).tz('Asia/Calcutta').format(dateFormat)



}
